fx_regular = {
	getParams: function (str) {
		return str.replace(/\s/g, "").split(",");
	},
	splitClasses: function (str) {
		return str.replace(/\s/g, "").split("|");
	},
	setItems: function () {
		const self = this;
		document.querySelectorAll("[regular]").forEach(($item, i) => {
			let params = self.getParams($item.getAttribute("regular"));
			const childrenClass = self.splitClasses(params[0]);
			const breakpoint = isNaN(params[1]) ? 0 : params[1];
			const windowWidth = window.innerWidth;

			childrenClass.forEach((className, i) => {
				let a = 0;
				let b = 0;

				if (windowWidth < breakpoint) {
					$item.querySelectorAll("." + className).forEach(($children, i) => {
						$children.style.height = "auto";
					});
				}

				if (windowWidth >= breakpoint) {
					$item.querySelectorAll("." + className).forEach(($children, i) => {
						$children.style.height = "auto";
					});

					$item.querySelectorAll("." + className).forEach(($children, i) => {
						a = $children.offsetHeight;

						if (a >= b) {
							b = a;
						}
					});

					$item.querySelectorAll("." + className).forEach(($children, i) => {
						$children.style.height = b + "px";
					});
				}
			});
		});
	},
	regularAvailable: function () {
		let isValid = true;
		const self = this;

		document.querySelectorAll("[regular]").forEach(($item, i) => {
			let params = self.getParams($item.getAttribute("regular"));
			const childrenClass = self.splitClasses(params[0]);

			childrenClass.forEach((children, i) => {
				if (typeof children === "undefined" || children === "") {
					isValid = false;
				}

				if (
					typeof children !== "undefined" &&
					children !== "" &&
					document.querySelector("." + children) === null
				) {
					isValid = false;
				}
			});
		});

		return isValid;
	},
	process: function () {
		let resizeTimer;
		const self = this;

		this.setItems();
		window.addEventListener("load", () => {
			self.setItems();
		});
		window.addEventListener(
			"resize",
			() => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(() => {
					self.setItems();
				}, 250);
			},
			false
		);
	},
	init: function () {
		if (this.regularAvailable()) this.process();
	},
};

document.addEventListener("DOMContentLoaded", () => {
	fx_regular.init();
});
